import { Pipe } from '@angular/core';
import { XsImagePipe } from './xs-image.pipe';

/* This pipe is a wrapper over XsImagePipe 
  The  assets path is set as '/sotixsight/get-resource/assets/images/' instead of '.assets/images/' */
@Pipe({
  name: 'lsImage',
  pure: false,
})
export class LsImagePipe extends XsImagePipe {
  transform(value: string, ...args: unknown[]): unknown {
    const imagePath = args.length === 0 ? '/sotixsight/get-resource/assets/images/' : args[0];
    return super.transform(value, imagePath);
  }
}
